import styled, { css } from "styled-components";
import { useSelector } from "react-redux";
import ScrollAnimation from "react-animate-on-scroll";

import { scrollAnimationProps as animationProps } from "globalConstants";

import * as Types from "Types";
import * as grid from "grid";

import AtomDescription1 from "Components/Atoms/Description1";

const Wrap = styled.div<Types.Default>`
   line-height: 31px;
   ${({ css }) => css}
`;

const XSWrap = styled.div<Types.Default>`
   margin-top: 20px;
   padding: 0 17px;
`;

const Text = styled(AtomDescription1)<Types.Default>`
   &:not(:first-child) {
      margin-top: 30px;
   }
   ${({ css }) => css}
`;

const XSText = styled(AtomDescription1)<Types.Default>`
   margin-top: 30px;
   ${({ css }) => css}
`;

export default function Content3(props: Types.Default) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const shows = grid.shows({
      width: windowWidth,
      grids: { xs: false },
   });
   return (
      <Wrap {...props}>
         {shows ? (
            <ScrollAnimation {...animationProps}>
               <Text>
                  <p>
                     아트맵은 행사의 성격과 관람 타겟층을 <b>분석</b>하여 <b>최대 효과</b>의 <b>온·오프라인 프로모션</b> 을 함께 진행합니다.
                  </p>
               </Text>
               <Text>
                  <p>아트맵만이 지닌 폭넓은 경험과 다양한 채널, 우수한 인적 자원으로</p>
                  <p>
                     전시회 뿐만 아니라 <b>다양한 미술 행사의 성공적인 개최를 지원</b>합니다.
                  </p>
               </Text>
            </ScrollAnimation>
         ) : (
            <XSWrap>
               <ScrollAnimation {...animationProps}>
                  <XSText
                     css={css`
                        margin-top: 0px;
                     `}>
                     아트맵은 행사의 성격과 관람 타겟층을 <b>분석</b>하여 <b>최대 효과</b>의 <b>온·오프라인 프로모션</b> 을 함께 진행합니다.
                  </XSText>
               </ScrollAnimation>
               <ScrollAnimation {...animationProps}>
                  <XSText>
                     아트맵만이 지닌 폭넓은 경험과 다양한 채널, 우수한 인적 자원으로 전시회 뿐만 아니라 <b>다양한 미술 행사의 성공적인 개최를 지원</b>합니다.
                  </XSText>
               </ScrollAnimation>
            </XSWrap>
         )}
      </Wrap>
   );
}
